"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHeadingEditDialog = createHeadingEditDialog;
var _dialog = require("../../ui/dialog");
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("solid-ui/components/forms/select");
require("solid-ui/components/media/photo-capture");
var _HeadingSection = require("./HeadingSection");
require("../../styles/EditDialogs.css");
var _mutations = require("./mutations");
var _phoneCountries = require("../shared/phoneCountries");
var _contactTypeUtils = require("../shared/contactTypeUtils");
var _rowState = require("../shared/rowState");
var _textUtils = require("../../textUtils");
var _texts = require("../../texts");
var _debug = require("../../utils/debug");
var _profileIcons = require("../../icons-svg/profileIcons");
var _sanitizeUtils = require("../shared/sanitizeUtils");
var _dateHelpers = require("./dateHelpers");
var _imageHelpers = require("./imageHelpers");
/* Note: new design - has address type in More Edit Contacts for now we will leave
         out Address Type, but a ticket will be created to add type later
         so I will keep the code and just comment it out for now. 
         new design - has country code, will comment out code for now and create a ticket to add later. */

const HEADING_PHONE_TYPE_OPTIONS = [{
  label: 'Mobile',
  value: 'Mobile'
}, {
  label: 'Home',
  value: 'Home'
}, {
  label: 'Work',
  value: 'Work'
}];
const HEADING_EMAIL_TYPE_OPTIONS = [{
  label: 'Personal',
  value: 'Personal'
}, {
  label: 'Office',
  value: 'Office'
}];
const HEADING_PRONOUN_OPTIONS = [{
  label: 'He/Him',
  value: 'He/Him'
}, {
  label: 'She/Her',
  value: 'She/Her'
}, {
  label: 'They/Them',
  value: 'They/Them'
}];
function isContactPointRow(row) {
  return 'value' in row;
}
function isAddressRow(row) {
  return 'streetAddress' in row;
}
function isProfileBasicRow(row) {
  return 'name' in row;
}
function normalizeHeadingContactTypeValue(value, options) {
  return options.some(option => option.value === value) ? value : options[0]?.value || '';
}
function readHeadingContactTypeChange(event) {
  const customEvent = event;
  if (typeof customEvent.detail?.value === 'string') {
    return customEvent.detail.value;
  }
  const target = event.target;
  return typeof target?.value === 'string' ? target.value : '';
}
function getHeadingContactTypeOptions(kind) {
  return kind === 'phone' ? HEADING_PHONE_TYPE_OPTIONS : HEADING_EMAIL_TYPE_OPTIONS;
}
function getHeadingContactTypeValue(kind, formState) {
  const row = kind === 'phone' ? formState.phone : formState.email;
  return normalizeHeadingContactTypeValue(row?.type || '', getHeadingContactTypeOptions(kind));
}
function withDefaultHeadingContactType(row, kind) {
  return {
    ...row,
    type: normalizeHeadingContactTypeValue(row.type || '', getHeadingContactTypeOptions(kind))
  };
}
function initializeHeadingContactTypeSelects(form, formState) {
  const selectElements = form.querySelectorAll('solid-ui-select[data-heading-contact-type-kind]');
  selectElements.forEach(selectElement => {
    const kind = selectElement.dataset.headingContactTypeKind;
    if (!kind) return;
    selectElement.options = getHeadingContactTypeOptions(kind);
    selectElement.value = getHeadingContactTypeValue(kind, formState);
    selectElement.label = '';
  });
}
function initializeHeadingPronounsSelect(form, formState) {
  const selectElement = form.querySelector('solid-ui-select[data-heading-basic-field="pronouns"]');
  if (!selectElement) return;
  selectElement.options = HEADING_PRONOUN_OPTIONS;
  selectElement.value = normalizePronounsValue(formState.basicInfo?.pronouns || '');
  selectElement.label = '';
}
function rowHasContent(row) {
  if (isContactPointRow(row)) {
    return (0, _textUtils.hasNonEmptyText)(row.value);
  }
  if (isAddressRow(row)) {
    return [row.streetAddress, row.locality, row.region, row.postalCode, row.countryName].some(_textUtils.hasNonEmptyText);
  }
  if (isProfileBasicRow(row)) {
    return [row.name, row.nickname, row.imageSrc, row.location, row.pronouns, row.dateOfBirth].some(_textUtils.hasNonEmptyText);
  }
  return false;
}
function normalizePronounsValue(value) {
  const normalized = (0, _textUtils.sanitizeTextValue)(value || '').toLowerCase().replace(/\s+/g, '');
  if (!normalized) return '';
  if (normalized === 'he' || normalized === 'he/him') return 'He/Him';
  if (normalized === 'she' || normalized === 'she/her') return 'She/Her';
  if (normalized === 'they' || normalized === 'they/them') return 'They/Them';
  return value || '';
}
function toFormState(profileData) {
  const basicInfo = {
    name: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.name)),
    nickname: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.nickname || '')),
    imageSrc: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.imageSrc || '')),
    location: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.location || '')),
    pronouns: normalizePronounsValue((0, _textUtils.toText)(profileData.pronouns || '')),
    dateOfBirth: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.dateOfBirth || '')),
    entryNode: (0, _textUtils.toText)(profileData.entryNode),
    status: (0, _textUtils.toText)(profileData.entryNode) ? 'existing' : 'new'
  };
  const primaryEmail = profileData.primaryEmail;
  const primaryPhone = profileData.primaryPhone;
  const primaryAddress = profileData.primaryAddress;
  const emailTypeWasMissing = !(0, _contactTypeUtils.normalizeEmailTypeForEdit)(primaryEmail?.type);
  const phoneTypeWasMissing = !(0, _contactTypeUtils.normalizePhoneTypeForEdit)(primaryPhone?.type);
  const normalizedEmailType = (0, _contactTypeUtils.normalizeEmailTypeForEdit)(primaryEmail?.type);
  const normalizedPhoneType = (0, _contactTypeUtils.normalizePhoneTypeForEdit)(primaryPhone?.type);
  const email = {
    value: (0, _sanitizeUtils.sanitizeEmailValue)((0, _textUtils.toText)(primaryEmail?.valueNode).replace(/^mailto:/i, '')),
    type: normalizedEmailType,
    entryNode: (0, _textUtils.toText)(primaryEmail?.entryNode),
    status: (0, _textUtils.toText)(primaryEmail?.entryNode) ? 'existing' : 'new'
  };
  const phone = {
    value: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(primaryPhone?.valueNode || primaryPhone?.entryNode || '').replace(/^tel:/i, '')),
    type: normalizedPhoneType,
    entryNode: (0, _textUtils.toText)(primaryPhone?.entryNode || ''),
    status: (0, _textUtils.toText)(primaryPhone?.entryNode || '') ? 'existing' : 'new'
  };
  const address = {
    streetAddress: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(primaryAddress?.streetAddress)),
    locality: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(primaryAddress?.locality)),
    region: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(primaryAddress?.region)),
    postalCode: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(primaryAddress?.postalCode)),
    countryName: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(primaryAddress?.countryName)),
    type: (0, _textUtils.toTypeLabel)(primaryAddress?.type),
    entryNode: (0, _textUtils.toText)(primaryAddress?.entryNode),
    status: (0, _textUtils.toText)(primaryAddress?.entryNode) ? 'existing' : 'new'
  };
  return {
    basicInfo: basicInfo ? basicInfo : {
      name: '',
      nickname: '',
      imageSrc: '',
      location: '',
      pronouns: '',
      dateOfBirth: '',
      entryNode: '',
      status: 'new'
    },
    email: email ? email : {
      value: '',
      type: '',
      entryNode: '',
      status: 'new'
    },
    phone: phone ? phone : {
      value: '',
      type: '',
      entryNode: '',
      status: 'new'
    },
    address: address ? address : {
      streetAddress: '',
      locality: '',
      region: '',
      postalCode: '',
      countryName: '',
      type: '',
      entryNode: '',
      status: 'new'
    },
    emailTypeWasMissing,
    phoneTypeWasMissing,
    imagePreviewSrc: '',
    clearImagePreview: () => undefined
  };
}
function setHeadingImagePreview(formState, file) {
  formState.clearImagePreview();
  if (typeof URL.createObjectURL !== 'function') {
    formState.imagePreviewSrc = '';
    formState.clearImagePreview = () => undefined;
    return;
  }
  const previewUrl = URL.createObjectURL(file);
  formState.imagePreviewSrc = previewUrl;
  formState.clearImagePreview = () => {
    URL.revokeObjectURL(previewUrl);
    formState.imagePreviewSrc = '';
    formState.clearImagePreview = () => undefined;
  };
}
function setResolvedHeadingPreview(formState, resolvedImageSrc) {
  formState.clearImagePreview();
  if (!resolvedImageSrc) {
    return;
  }
  formState.imagePreviewSrc = resolvedImageSrc;
  if (resolvedImageSrc.startsWith('blob:') && typeof URL.revokeObjectURL === 'function') {
    formState.clearImagePreview = () => {
      URL.revokeObjectURL(resolvedImageSrc);
      formState.imagePreviewSrc = '';
      formState.clearImagePreview = () => undefined;
    };
    return;
  }
  formState.clearImagePreview = () => {
    formState.imagePreviewSrc = '';
    formState.clearImagePreview = () => undefined;
  };
}
function mapEmailOpsForSave(ops) {
  const mapRow = row => ({
    ...withDefaultHeadingContactType(row, 'email'),
    type: (0, _contactTypeUtils.toSavedHeadingEmailType)(withDefaultHeadingContactType(row, 'email').type)
  });
  return {
    create: ops.create.map(mapRow),
    update: ops.update.map(mapRow),
    remove: ops.remove.map(mapRow)
  };
}
function mapPhoneOpsForSave(ops) {
  const mapRow = row => ({
    ...withDefaultHeadingContactType(row, 'phone'),
    type: (0, _contactTypeUtils.toSavedHeadingPhoneType)(withDefaultHeadingContactType(row, 'phone').type)
  });
  return {
    create: ops.create.map(mapRow),
    update: ops.update.map(mapRow),
    remove: ops.remove.map(mapRow)
  };
}
function summarizeHeadingContactOps(row, kind, typeWasMissing) {
  const ops = (0, _rowState.summarizeRowOps)([row], rowHasContent);
  if (typeWasMissing && row.entryNode && row.status === 'existing' && rowHasContent(row) && ops.create.length === 0 && ops.update.length === 0 && ops.remove.length === 0) {
    return {
      create: ops.create,
      update: [withDefaultHeadingContactType({
        ...row,
        status: 'modified'
      }, kind)],
      remove: ops.remove
    };
  }
  return ops;
}
function renderContactPhoneInput({
  phone
}) {
  const label = 'Phone Number 1';
  const typeLabel = 'Phone Type 1';
  const inputName = 'phone-value';
  const splitValue = (0, _phoneCountries.splitPhoneValue)(phone?.value || '');
  let selectedDialCode = splitValue.dialCode;
  const handleValueInput = e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizePhoneLocalValue)(target.value);
    if (phone) {
      (0, _rowState.applyRowFieldChange)(phone, 'value', (0, _phoneCountries.combinePhoneValue)(selectedDialCode, nextValue), rowHasContent);
    }
  };
  const handleTypeInput = e => {
    const nextType = readHeadingContactTypeChange(e);
    if (phone) {
      (0, _rowState.applyRowSelectChange)(phone, 'type', nextType);
    }
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--equal profile-edit-dialog__row--contact-point">
      <div class="profile-edit-dialog__field">
        <label aria-label=${label} class="label">
          <input
            class="input"
            type="tel"
            name=${inputName}
            .value=${splitValue.localNumber}
            required
            data-contact-field="value"
            data-entry-node=${phone?.entryNode || ''}
            data-row-status=${phone?.status || 'n/a'}
            placeholder=${label}
            autocomplete="tel-national"
            inputmode="tel"
            @input=${handleValueInput}
          />
        </label>
      </div>
      <label aria-label=${typeLabel} class="label profile-edit-dialog__field-type profile-edit-dialog__field-type--contact-point">
        <solid-ui-select
          class="profile-edit-dialog__type-select"
          id=${`phone-type-select-${inputName}`}
          data-heading-contact-type-kind="phone"
          aria-label=${typeLabel}
          .label=${''}
          .options=${HEADING_PHONE_TYPE_OPTIONS}
          .value=${normalizeHeadingContactTypeValue(phone?.type || '', HEADING_PHONE_TYPE_OPTIONS)}
          @change=${handleTypeInput}
        ></solid-ui-select>
      </label>
    </div>
  `;
}
function renderContactEmailInputRow({
  email
}) {
  const label = 'Email Address';
  const typeLabel = 'Email Type';
  const inputName = 'email-value';
  const handleValueInput = e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeEmailValue)(target.value);
    if (email) {
      (0, _rowState.applyRowFieldChange)(email, 'value', nextValue, rowHasContent);
    }
  };
  const handleTypeInput = e => {
    const nextType = readHeadingContactTypeChange(e);
    if (email) {
      (0, _rowState.applyRowSelectChange)(email, 'type', nextType);
    }
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--equal profile-edit-dialog__row--contact-point">
      <label aria-label=${label} class="label profile-edit-dialog__field">
        <input
          class="input"
          type="email"
          name=${inputName}
          .value=${email?.value || ''}
          required
          data-contact-field="value"
          data-entry-node=${email?.entryNode || ''}
          data-row-status=${email?.status || 'n/a'}
          placeholder="Email Address"
          autocomplete="email"
          inputmode="email"
          @input=${handleValueInput}
        />
      </label>
      <label aria-label=${typeLabel} class="label profile-edit-dialog__field-type profile-edit-dialog__field-type--contact-point">
        <solid-ui-select
          class="profile-edit-dialog__type-select"
          id=${`email-type-select-${inputName}`}
          data-heading-contact-type-kind="email"
          aria-label=${typeLabel}
          .label=${''}
          .options=${HEADING_EMAIL_TYPE_OPTIONS}
          .value=${normalizeHeadingContactTypeValue(email?.type || '', HEADING_EMAIL_TYPE_OPTIONS)}
          @change=${handleTypeInput}
        ></solid-ui-select>
      </label>
    </div>
  `;
}
function renderContactAddressInput({
  address
}) {
  const label = 'Address';
  /* const typeLabel = 'Address Type' */
  /* const typeInputName = 'address-type' */
  /* const addressTypeSelectId = 'address-type-select' */
  const streetAddressName = 'address-street';
  const localityName = 'address-locality';
  const regionName = 'address-region';
  const postalCodeName = 'address-postal';
  const countryName = 'address-country';
  const handleAddressInput = field => e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeAddressFieldValue)(target.value);
    if (address) {
      (0, _rowState.applyRowFieldChange)(address, field, nextValue, rowHasContent);
    }
  };

  /* const handleTypeInput = (e: Event) => {
    const target = e.target as HTMLInputElement
    const nextType = target.value
    if (address) {
      applyRowSelectChange(address, 'type', nextType)
    } 
  } */

  return (0, _litHtml.html)`
    <label aria-label=${`${label} Street`} class="label profile-edit-dialog__field profile-edit-dialog__field--row-width">
      Street Address
      <input
        class="input"
        type="text"
        name=${streetAddressName}
        .value=${address?.streetAddress || ''}
        required
        data-contact-field="streetAddress"
        data-entry-node=${address?.entryNode || ''}
        data-row-status=${address?.status || 'n/a'}
        placeholder="Street Address"
        autocomplete="street-address"
        inputmode="text"
        @change=${handleAddressInput('streetAddress')}
      />
    </label>

    <div class="profile-edit-dialog__row profile-edit-dialog__row--equal profile-edit-dialog__row--full">
      <label aria-label=${`${label} Locality`} class="label profile-edit-dialog__field">
        Locality
        <input
          class="input"
          type="text"
          name=${localityName}
          .value=${address?.locality || ''}
          data-contact-field="locality"
          data-entry-node=${address?.entryNode || ''}
          data-row-status=${address?.status || 'n/a'}
          placeholder="City / Locality"
          autocomplete="address-level2"
          inputmode="text"
          @change=${handleAddressInput('locality')}
        />
      </label>
      <label aria-label=${`${label} Postal Code`} class="label profile-edit-dialog__field">
        Postal Code
        <input
          class="input"
          type="text"
          name=${postalCodeName}
          .value=${address?.postalCode || ''}
          data-contact-field="postalCode"
          data-entry-node=${address?.entryNode || ''}
          data-row-status=${address?.status || 'n/a'}
          placeholder="Postal Code"
          autocomplete="postal-code"
          inputmode="text"
          @change=${handleAddressInput('postalCode')}
        />
      </label>
    </div>

    <div class="profile-edit-dialog__row profile-edit-dialog__row--equal profile-edit-dialog__row--full">
      <label aria-label=${`${label} Region`} class="label profile-edit-dialog__field">
        Region
        <input
          class="input"
          type="text"
          name=${regionName}
          .value=${address?.region || ''}
          data-contact-field="region"
          data-entry-node=${address?.entryNode || ''}
          data-row-status=${address?.status || 'n/a'}
          placeholder="State / Region"
          inputmode="text"
          @change=${handleAddressInput('region')}
        />
      </label>
      <label aria-label=${`${label} Country`} class="label profile-edit-dialog__field">
        Country
        <input
          class="input"
          type="text"
          name=${countryName}
          .value=${address?.countryName || ''}
          data-contact-field="countryName"
          data-entry-node=${address?.entryNode || ''}
          data-row-status=${address?.status || 'n/a'}
          placeholder="Country"
          autocomplete="country-name"
          inputmode="text"
          @change=${handleAddressInput('countryName')}
        />
      </label>
    </div>
  `;
}
function renderHeadingInfoInput(store, subject, formState, rerender) {
  const {
    basicInfo,
    phone,
    email,
    imagePreviewSrc
  } = formState;
  const imageSrcLabel = 'Profile Photo';
  const recommendedImageToLoad = 'Recommended: Square JPG, PNG. Max 2MB.';
  const nameLabel = 'Full Name';
  const nicknameLabel = 'Nickname';
  const pronounsLabel = 'Pronouns';
  const dateOfBirthLabel = 'DOB';
  const handleBasicInfoInput = field => e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeBasicInputFieldValue)(target.value);
    if (basicInfo) {
      (0, _rowState.applyRowFieldChange)(basicInfo, field, nextValue, rowHasContent);
    }
  };
  const handleDateOfBirthInput = e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeBasicInputFieldValue)(target.value);
    if (basicInfo) {
      (0, _rowState.applyRowFieldChange)(basicInfo, 'dateOfBirth', (0, _dateHelpers.toStorageDateISO)(nextValue), rowHasContent);
    }
  };
  const handlePronounsInput = e => {
    const nextValue = normalizePronounsValue(readHeadingContactTypeChange(e));
    if (basicInfo) {
      (0, _rowState.applyRowSelectChange)(basicInfo, 'pronouns', nextValue);
    }
  };
  const handleUpload = async e => {
    const button = e.currentTarget;
    const dom = button?.ownerDocument || document;
    const fileInput = dom.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.hidden = true;
    const cleanupFileInput = () => {
      fileInput.remove();
    };
    fileInput.addEventListener('change', async () => {
      const file = fileInput.files?.[0];
      cleanupFileInput();
      if (!file || !basicInfo) return;
      try {
        const uploadedUri = await (0, _imageHelpers.uploadPhotoFile)(store, subject, file);
        setHeadingImagePreview(formState, file);
        (0, _rowState.applyRowFieldChange)(basicInfo, 'imageSrc', uploadedUri, rowHasContent);
        rerender();
      } catch (error) {
        (0, _debug.error)('Profile image upload failed', error);
      }
    }, {
      once: true
    });
    dom.body.appendChild(fileInput);
    fileInput.click();
  };
  const handleCameraClick = async e => {
    e.preventDefault();
    const button = e.currentTarget;
    const headingPhotoRow = button?.closest('.profile-edit-dialog__row--heading-photo');
    const hostRow = headingPhotoRow?.nextElementSibling;
    const frame = hostRow?.querySelector('.profile-edit-dialog__image-camera-capture-frame');
    if (!frame || frame.dataset.active === 'true') return;
    frame.hidden = false;
    frame.dataset.active = 'true';
    frame.replaceChildren();
    const closeCameraFrame = () => {
      frame.replaceChildren();
      frame.hidden = true;
      frame.dataset.active = 'false';
    };
    try {
      const photoCapture = document.createElement('solid-ui-photo-capture');
      photoCapture.classList.add('profile-edit-dialog__photo-capture');
      photoCapture.heading = '';
      photoCapture.captureLabel = 'Take Photo';
      photoCapture.confirmLabel = 'Use Photo';
      photoCapture.retakeLabel = 'Retake';
      photoCapture.cancelLabel = 'Close camera';
      photoCapture.presentation = 'inline';
      photoCapture.showTrigger = false;
      photoCapture.showCancelButton = true;
      photoCapture.autoCloseOnCapture = false;
      photoCapture.fileNamePrefix = 'camera';
      photoCapture.facingMode = 'user';
      photoCapture.open = true;
      photoCapture.addEventListener('cancel', event => {
        event.preventDefault();
        event.stopPropagation();
        closeCameraFrame();
      });
      photoCapture.addEventListener('photo-captured', async event => {
        const detail = event.detail;
        if (!detail?.file || !basicInfo) return;
        try {
          const uploadedUri = await (0, _imageHelpers.uploadPhotoFile)(store, subject, detail.file);
          closeCameraFrame();
          setHeadingImagePreview(formState, detail.file);
          (0, _rowState.applyRowFieldChange)(basicInfo, 'imageSrc', uploadedUri, rowHasContent);
          rerender();
        } catch (error) {
          (0, _debug.error)('Profile camera upload failed', error);
        }
      });
      frame.appendChild(photoCapture);
    } catch (error) {
      closeCameraFrame();
      (0, _debug.error)('Camera control failed to initialize', error);
    }
  };
  const handleDelete = async _e => {
    if (!basicInfo) return;
    formState.clearImagePreview();
    (0, _rowState.applyRowFieldChange)(basicInfo, 'imageSrc', '', rowHasContent);
    rerender();
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--heading-photo">
      <header class="profile-edit-dialog__image-preview-header" aria-label="Profile Image">
        <div class="profile-edit-dialog__image-frame">
          ${(0, _HeadingSection.Image)(imagePreviewSrc || basicInfo.imageSrc, basicInfo.name)}
          <solid-ui-button
            type="button"
            class="profile-edit-dialog__image-camera-button"
            variant="icon"
            size="md"
            aria-label="Take a photo"
            title="Take a photo"
            @click=${handleCameraClick}
          >
            <span slot="icon" aria-hidden="true">${_profileIcons.cameraIcon}</span>
          </solid-ui-button>
        </div>
      </header>

      <div class="profile-edit-dialog__image-preview" aria-label="Profile Photo Preview">
        <p class="profile-edit-dialog__image-preview-label"><strong>${imageSrcLabel}</strong></p>
        <p class="profile-edit-dialog__image-preview-description">${recommendedImageToLoad}</p>

        <div class="profile-edit-dialog__image-preview-actions">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="md"
            label="Upload New"
            class="profile-edit-dialog__image-button profile-edit-dialog__image-upload-button"
            aria-label="Upload new profile photo"
            title="Upload New"
            @click=${handleUpload}
          >
            Upload New
          </solid-ui-button>
          <solid-ui-button
            type="button"
            variant="secondary"
            size="md"
            label="Remove"
            class="profile-edit-dialog__image-button profile-edit-dialog__image-remove-button"
            aria-label="Delete profile photo"
            title="Remove"
            @click=${handleDelete}
          >
            Remove
          </solid-ui-button>
        </div>
      </div>
    </div>
    <div class="profile-edit-dialog__image-camera-capture-row">
      <div class="profile-edit-dialog__image-camera-capture-frame" hidden></div>
    </div>
    <div class="profile-edit">
      <div class="profile-edit-dialog__row profile-edit-dialog__row--equal">
        <label aria-label=${nameLabel} class="label profile-edit-dialog__field">
          ${nameLabel}
          <input
            class="input"
            type="text"
            name="name"
            .value=${basicInfo?.name || ''}
            required
            data-contact-field="name"
            data-entry-node=${basicInfo?.entryNode || ''}
            data-row-status=${basicInfo?.status || 'n/a'}
            placeholder="Full Name"
            autocomplete="name"
            inputmode="text"
            @change=${handleBasicInfoInput('name')}
          />
        </label>
        <label aria-label=${nicknameLabel} class="label profile-edit-dialog__field">
          ${nicknameLabel}
          <input
            class="input"
            type="text"
            name="nickname"
            .value=${basicInfo?.nickname || ''}
            data-contact-field="nickname"
            data-entry-node=${basicInfo?.entryNode || ''}
            data-row-status=${basicInfo?.status || 'n/a'}
            placeholder="Nickname"
            autocomplete="nickname"
            inputmode="text"
            @change=${handleBasicInfoInput('nickname')}
          />
        </label>
      </div>
      <div class="profile-edit-dialog__row profile-edit-dialog__row--equal profile-edit-dialog__row--heading-dob">
        <label aria-label=${pronounsLabel} class="label profile-edit-dialog__field-type profile-edit-dialog__field--stack">
          ${pronounsLabel}
          <solid-ui-select
            class="profile-edit-dialog__type-select"
            id="heading-pronouns-select"
            name="pronouns"
            data-heading-basic-field="pronouns"
            aria-label=${pronounsLabel}
            .label=${''}
            .options=${HEADING_PRONOUN_OPTIONS}
            .value=${normalizePronounsValue(basicInfo?.pronouns || '')}
            @change=${handlePronounsInput}
          ></solid-ui-select>
        </label>
        <label aria-label=${dateOfBirthLabel} class="label profile-edit-dialog__field profile-edit-dialog__field--dob">
          ${dateOfBirthLabel}
          <input
            class="input profile-edit-dialog__input--dob"
            type="date"
            name="profile-date-of-birth"
            .value=${(0, _dateHelpers.toStorageDateISO)(basicInfo?.dateOfBirth)}
            data-contact-field="dateOfBirth"
            data-entry-node=${basicInfo?.entryNode || ''}
            data-row-status=${basicInfo?.status || 'n/a'}
            autocomplete="off"
            data-lpignore="true"
            data-1p-ignore="true"
            data-bwignore="true"
            @change=${handleDateOfBirthInput}
          />
        </label>
      </div>
      <div class="profile-edit-dialog__row profile-edit-dialog__row--equal">
        <div class="profile-edit-dialog__field profile-edit-dialog__field--full">
          ${renderContactPhoneInput({
    phone
  })}
        </div>
        <div class="profile-edit-dialog__field profile-edit-dialog__field--full">
          ${renderContactEmailInputRow({
    email
  })}
        </div>
      </div>
    </div>
  `;
}
function renderHeadingEditTemplate(form, formState, store, subject, viewerMode) {
  const rerender = () => renderHeadingEditTemplate(form, formState, store, subject, viewerMode);
  (0, _litHtml.render)((0, _litHtml.html)`
    ${renderHeadingInfoInput(store, subject, formState, rerender)}
    ${renderContactAddressInput({
    address: formState.address
  })}
    ${viewerMode !== 'owner' ? (0, _litHtml.html)`<p class="profile-edit-dialog__login-message">${_texts.ownerLoginRequiredDialogMessageText}</p>` : null}
  `, form);
  initializeHeadingContactTypeSelects(form, formState);
  initializeHeadingPronounsSelect(form, formState);
}
function createHeadingEditForm(store, subject, profileData, viewerMode) {
  const form = document.createElement('form');
  form.classList.add('profile__edit-form', 'profile__edit-form--heading', 'profile-edit-dialog--heading');
  form.autocomplete = 'off';
  form.setAttribute('data-lpignore', 'true');
  form.setAttribute('data-1p-ignore', 'true');
  form.setAttribute('data-bwignore', 'true');
  const formState = toFormState(profileData);
  renderHeadingEditTemplate(form, formState, store, subject, viewerMode);
  return {
    form,
    formState
  };
}
function isValidHeadingEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
function isValidHeadingPhoneNumber(value) {
  return /^\d+$/.test(value);
}
function validateHeadingDataBeforeSave(formState) {
  const {
    localNumber
  } = (0, _phoneCountries.splitPhoneValue)(formState.phone?.value || '');
  if (rowHasContent(formState.phone) && !isValidHeadingPhoneNumber(localNumber)) {
    return 'Phone Number 1 should contain only numbers.';
  }
  if (rowHasContent(formState.email) && !isValidHeadingEmailAddress(formState.email?.value || '')) {
    return 'Email address must be a valid email address.';
  }
  return null;
}
async function createHeadingEditDialog(_event, store, subject, profileData, viewerMode, onSaved) {
  const dom = document;
  const originalPhotoUri = (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(profileData.imageSrc || ''));
  const {
    form,
    formState
  } = createHeadingEditForm(store, subject, profileData, viewerMode);
  if (formState.basicInfo.imageSrc) {
    const resolvedImageSrc = await (0, _imageHelpers.resolvePhotoDisplaySrc)(store, formState.basicInfo.imageSrc);
    if (resolvedImageSrc && resolvedImageSrc !== formState.basicInfo.imageSrc) {
      setResolvedHeadingPreview(formState, resolvedImageSrc);
      renderHeadingEditTemplate(form, formState, store, subject, viewerMode);
    }
  }
  const result = await (0, _dialog.openInputDialog)({
    title: _texts.editHeadingDialogTitleText,
    dom,
    form,
    headerAction: {
      type: 'none'
    },
    submitLabel: _texts.dialogSubmitLabelText,
    cancelLabel: _texts.dialogCancelLabelText,
    shouldCloseWithoutSave: () => {
      const basicInfoOps = (0, _rowState.summarizeRowOps)([formState.basicInfo], rowHasContent);
      const phoneOps = summarizeHeadingContactOps(formState.phone, 'phone', formState.phoneTypeWasMissing);
      const emailOps = summarizeHeadingContactOps(formState.email, 'email', formState.emailTypeWasMissing);
      const addressOps = (0, _rowState.summarizeRowOps)([formState.address], rowHasContent);
      return basicInfoOps.create.length === 0 && basicInfoOps.update.length === 0 && basicInfoOps.remove.length === 0 && phoneOps.create.length === 0 && phoneOps.update.length === 0 && phoneOps.remove.length === 0 && emailOps.create.length === 0 && emailOps.update.length === 0 && emailOps.remove.length === 0 && addressOps.create.length === 0 && addressOps.update.length === 0 && addressOps.remove.length === 0;
    },
    validate: () => {
      if (viewerMode !== 'owner') {
        return _texts.ownerLoginRequiredDialogMessageText;
      }
      return validateHeadingDataBeforeSave(formState);
    },
    onSave: async () => {
      const phoneOps = summarizeHeadingContactOps(formState.phone, 'phone', formState.phoneTypeWasMissing);
      const emailOps = summarizeHeadingContactOps(formState.email, 'email', formState.emailTypeWasMissing);
      const plan = {
        basicOps: (0, _rowState.summarizeRowOps)([formState.basicInfo], rowHasContent),
        phoneOps: mapPhoneOpsForSave(phoneOps),
        emailOps: mapEmailOpsForSave(emailOps),
        addressOps: (0, _rowState.summarizeRowOps)([formState.address], rowHasContent)
      };
      await (0, _mutations.processHeadingMutations)(store, subject, plan);
      const nextPhotoUri = (0, _textUtils.sanitizeTextValue)(formState.basicInfo.imageSrc || '');
      if (originalPhotoUri && originalPhotoUri !== nextPhotoUri) {
        try {
          await (0, _imageHelpers.deletePhotoFile)(store, subject, originalPhotoUri);
        } catch (error) {
          (0, _debug.warn)('Profile image file delete failed', error);
        }
      }
    },
    formatSaveError: error => {
      return error instanceof Error ? error.message : _texts.saveHeadingUpdatesFailedMessageText;
    }
  });
  if (!result) return;
  if (onSaved) {
    await onSaved();
  }
}